import { t } from "i18next";
import { useEffect, useState } from "react";
import { CourseService } from "../../services/CourseService";
import { sort } from "../../utils/utils";
import { ERROR, useNotification } from "../CustomHooks/NotificationProvider";
import { MULTI, SINGLE, Selector } from "./Selector";

export const ContextSelector = ({
  departments,
  selectHandler,
  selectedContexts,
  isSingle = false,
  id,
  interaction,
  creationMethod,
  isRequired,
}) => {
  const showNotification = useNotification();
  const [contexts, setContexts] = useState([]);
  const [clear, setClear] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(
    isSingle && selectedContexts && selectedContexts.length > 0
      ? selectedContexts[0].id
      : ""
  );

  useEffect(() => {
    if (departments) {
      setClear(true);
      CourseService.getCourses({
        ownerCourseCode: departments.map((dep) => dep.title),
        approval: "off",
        creationMethod: creationMethod,
      })
        .then((coursesWithPaging) => {
          let contextsData = coursesWithPaging.data;
          let selectorData = [];
          contextsData.forEach((course) => {
            if (course.offerings.length > 0) {
              const courseOption = {
                id: course.offerings[0].id,
                label: course.offerings[0].code,
              };
              selectorData.push(courseOption);
            }
          });

          selectorData = sort(selectorData, (option) => option.label);
          setContexts(selectorData);
        })
        .catch(() => {
          showNotification(
            t("notifications.general.fetchError", {
              obj: t("navigation.courses"),
            }),
            ERROR
          );
        })
        .finally(() => {
          setClear(false);
        });
    }
  }, [departments, showNotification]);

  const selectHandlerWrapper = (selectedContexts) => {
    if (isSingle) {
      setSelectedItemId(selectedContexts.id);
    }
    selectHandler(selectedContexts);
  };

  return (
    <Selector
      interaction={interaction}
      type={isSingle ? SINGLE : MULTI}
      id={id || "context-selector"}
      label={
        t("assessment.assessmentExternalContext") + (isRequired ? "*" : "")
      }
      options={contexts}
      selectHandler={selectHandlerWrapper}
      assistiveText={t("curriculumMap.selectCoursesAssistive")}
      size="small"
      clear={clear}
      selectedOptions={!isSingle && selectedContexts ? selectedContexts : null}
      selectedItemId={selectedItemId}
    />
  );
};
